import ModalInformation from './ModalInformation'
export default ModalInformation
